import { formatClockTime } from '@boatnav/core';
import { useFollowStore } from './followStore.js';
import { useFollowMetrics } from './useFollow.js';
import { msg } from '../../lib/messages.js';
import './follow-banner.css';

/** Route-following banner over the map: name, live ETA, stop button (spec 05). */
export function FollowBanner(): JSX.Element | null {
  const route = useFollowStore((s) => s.route);
  const stop = useFollowStore((s) => s.stop);
  const metrics = useFollowMetrics();
  if (!route) return null;

  return (
    <div className="follow-banner">
      <div className="follow-banner__info">
        <span className="follow-banner__name">{route.name}</span>
        {metrics?.etaMs != null && (
          <span className="follow-banner__eta numeral">
            {msg.planner.arrival} {formatClockTime(metrics.etaMs)}
          </span>
        )}
      </div>
      <button type="button" className="follow-banner__stop" onClick={stop}>
        {msg.planner.stopFollow}
      </button>
    </div>
  );
}
